import {
    COLD,
    EXTRA_HOT,
    HOT,
    TRating,
    WARM,
} from 'src/constants/lead/ratings';

/**
 * Returns the color of the label based on the rating
 *
 * @param {string} rating - The rating to get the color for
 * @return {*}  {string}
 */
export const getRatingLabelColor = (rating: TRating): string => {
    if (rating === HOT) return 'error';
    if (rating === EXTRA_HOT) return 'extrahot';
    if (rating === WARM) return 'warning';
    if (rating === COLD) return 'blue';

    return 'primary';
};
